import React from "react";

import { QuestionnairePageType } from "@common/dto/questionnaire/page/type";
import { QuestionnaireConsentTabCreateDto, QuestionnaireConsentTabUpdateDto } from "@common/dto/questionnaire/consent-tab";

import { ConsentProps } from "./consent.types";

export const useConsentController = (props: ConsentProps) => {
  const {
    onChange,
    questionnaire,
  } = props;

  const currentEditingPage = React.useMemo(() => {
    return {
      ...questionnaire.consentTab,
      enabled: questionnaire.homeTab?.showConsent ?? questionnaire.consentTab.enabled ?? false,
    };
  }, [questionnaire.consentTab]);

  const handleFieldChange = React.useCallback((params: Partial<QuestionnaireConsentTabUpdateDto> | Partial<QuestionnaireConsentTabCreateDto>) => {
    onChange({
      ...questionnaire,
      homeTab: {
        ...questionnaire.homeTab,
        showConsent: params.enabled ?? questionnaire.consentTab.enabled ?? false,
      },
      consentTab: {
        ...questionnaire.consentTab,
        ...params,
        pageType: QuestionnairePageType.consent,
      },
    });
  }, [onChange, questionnaire]);

  return {
    currentEditingPage,
    handleFieldChange
  };
};
